export const convertCourseDetailRes = (courseRes: any[]) => {
  const chapterMaps = courseRes.reduce((chapterMaps: any, classDetail: any) => {
    let chapterMap = chapterMaps[classDetail.chapter_id];
    if (!chapterMap) {
      chapterMap = {
        id: classDetail.chapter_id,
        name: classDetail.chapter_name,
        classes: []
      };
      chapterMaps[classDetail.chapter_id] = chapterMap;
    }
    chapterMap.classes.push({
      id: classDetail.class_id,
      name: classDetail.class_name,
      guid: classDetail.classGuid,
      eva: classDetail.eva
    });
    return chapterMaps;
  }, {});
  const chapterArray = Object.values(chapterMaps).sort(
    (a: any, b: any) => parseInt(a.id) - parseInt(b.id)
  );

  return chapterArray.map((chapter: any) => {
    chapter.classes = chapter.classes.sort(
      (a: any, b: any) => parseInt(a.id) - parseInt(b.id)
    );
    return chapter;
  });
};
